import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useReservationStyles } from "../../assests/styles/views/Reservations/reservationStyles";
import { Helmet } from "react-helmet";
import { getTranslation } from "../../heplers/translationHelper";
import { StyledToggleButtonGroup } from "../../components";
import ToggleButton from "@material-ui/lab/ToggleButton";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import Brightness6Icon from "@material-ui/icons/Brightness6";
import Filtration from "./components/filtration";
import Progressbar from "./components/progressbar";
import ReservationTable from "./components/Table";
import { SET_LASTUPDATEOFRESERVATIONS } from "../../constants/types";
import { Get, Post } from "../../actions";
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { Get_All_Print_Reservation_URL, Get_Reservation_URL, Get_Reservations_URL, Get_Summary_URL } from "../../constants/apiUrls";
import CardComponent from "../../components/Card";
import { Add, AddCircleOutline, ChevronLeft, ChevronRight, EventSeat, PrintRounded, TableChart } from "@material-ui/icons";
import { ToggleButtonGroup } from "@material-ui/lab";
import { useReactToPrint } from "react-to-print";
import { AddReservationModal } from "./components/addReservationModal";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, makeStyles, Typography, Chip, Paper, Badge, Fab } from "@material-ui/core";
import { SeatingPlanCanvas } from "./components/SeatingPlanCanvas";
import ButtonWithLoading from "../../components/ButtonWithLoading";
import { StopReservationButton } from "../../components/ButttonsWithIcons";
import { format } from "../../heplers/format";
import dayjs from "dayjs";
import ReservationMobileView from "./components/Reservationmobileview";
import EditReservationModal from "./components/EditReservationModal";

const CurrentReservation = () => {
  const classes = useReservationStyles();
  const location = useLocation();
  const [queryParams, setQueryParams] = useState({
    selectedDayTime: 0,
    // "MM-DD-YYYY" like the day bar: a Date is sent to the API in UTC and can become the previous day
    selectedDate: dayjs().format("MM-DD-YYYY"),
    pageNumber: 0,
    pageSize: 10,
    totalCount: 1,
    searchString: "",
    status: "all"
  });
  const [isLoadingReservation, setIsLoadingReservation] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [stats, setStats] = useState({
    maxCapacity: 100,
    numberOfGroups: 10,
    numberOfPersons: 50,
    percentage: "50%",
  });
  const [printData, setPrintData] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [alignment, setAlignment] = useState(0);
  const [tableSummary, setTableSummary] = useState([]);
  const [view, setView] = useState("table");
  const [refreshKey, setRefreshKey] = useState(0);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [selectedDayTime, setSelectedDayTime] = useState(0);
  const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState({
    persons: 0,
    reservationDate: Date.now(),
    purposeOfReservation: 0,
    timeSlotId: "",
    title: "",
    email: "",
    phone: "",
    subscribeForNews: false,
    haveSmallKids: false,
    kids: 0,
    acceptTerms: false,
    allergies: "",
  });
  const [showAddReservationForm, setShowAddReservationForm] = useState(false);
  // reservation opened from a customer email link by a logged-in staff member
  const [linkedReservationId, setLinkedReservationId] = useState(location.state?.editReservationId ?? null);
  const [linkedReservation, setLinkedReservation] = useState(null);

  useEffect(() => {
    if (location.state?.openAddDialog) {
      setShowAddReservationForm(true);
    }
    if (location.state?.editReservationId) {
      // drop the state so a page refresh does not open the reservation again; done on the browser
      // history directly: a router navigation would remount this page and lose the reservation
      window.history.replaceState(null, "", location.pathname);
      openLinkedReservationDay(location.state.editReservationId);
    }
  }, []);

  // show the day and service of the linked reservation; the edit window opens once that list is loaded
  const openLinkedReservationDay = (id) => {
    Get(
      { id },
      Get_Reservation_URL,
      null,
      (res) => {
        const dayTime = res?.data?.timeSlots?.[0]?.dayTime ?? 0;
        setSelectedDayTime(dayTime);
        setAlignment(dayTime);
        setQueryParams((q) => ({ ...q, selectedDate: dayjs(res.data.reservationDate).format("MM-DD-YYYY"), selectedDayTime: dayTime }));
      },
      () => {
        setLinkedReservationId(null);
        enqueueSnackbar(getTranslation("Reservation not found"), { variant: "error" });
      }
    );
  };

  useEffect(() => {
    if (!linkedReservationId || isLoadingReservation) return;
    const row = reservations?.find((r) => r.id === linkedReservationId);
    if (row) {
      setLinkedReservation(row);
      setLinkedReservationId(null);
    }
  }, [reservations, isLoadingReservation]);

  // Fetch all time slots
  const getTimeSlots = () => {
    setIsLoadingTimeSlots(true);
    Get(
      { day: getDayEnum(queryParams.selectedDate) },
      "Reservation/GetTimeSlots",
      null,
      (res) => {
        setIsLoadingTimeSlots(false);
        const toMinutes = (s = "") => {
          const timePart = s.includes("T") ? s.split("T").pop() : s;
          const [h, m] = timePart.split(":").map(Number);
          return (h || 0) * 60 + (m || 0);
        };
        setTimeSlots(res?.data?.length > 0
          ? [...res.data].sort((a, b) => toMinutes(a.startDateTime) - toMinutes(b.startDateTime))
          : []);
      },
      (err) => {
        setIsLoadingTimeSlots(false);
        enqueueSnackbar(
          err?.data
            ? getTranslation(err?.data, err?.data, err?.data)
            : getTranslation(
              "Failed to load time slots",
              "Failed to load time slots",
              "Failed to load time slots"
            ),
          {
            variant: "error",
          }
        );
      }
    );
  };


  const getDayEnum = (date) => {
 return dayjs(date).day(); 
 
};
  const getReservations = (payload) => {
    setIsLoadingReservation(true);
    Get(
      payload,
      Get_Reservations_URL,
      null,
      (res) => {
        const statsData = {
          maxCapacity: res?.data.maxCapacity,
          numberOfGroups: res?.data.numberOfGroups,
          numberOfPersons: res?.data.numberOfPersons,
          percentage: res?.data.percentage,
        };
        setIsLoadingReservation(false);
        setReservations(res?.data?.data);
        setStats(statsData);
      },
      (err) => {
        setIsLoadingReservation(false);
        enqueueSnackbar(
          err?.data
            ? getTranslation(err?.data, err?.data, err?.data)
            : getTranslation(
              "Something went wrong. Please contact with admin.",
              "Something went wrong. Please contact with admin.",
              "Something went wrong. Please contact with admin."
            ),
          {
            variant: "error",
          }
        );
      }
    );
    Get(
      { date: queryParams.selectedDate },
      Get_Summary_URL,
      null,
      (resp) => {
        setTableSummary(resp.data);
      },
      () => { }
    );
  };

  const getAllPrintReservations = (payload) => {
    setIsLoadingReservation(true);
    Get(
      payload,
      Get_All_Print_Reservation_URL,
      null,
      (res) => {
        setIsLoadingReservation(false);
        setPrintData(res?.data);
        setTimeout(() => {
          print();
        }, 1000);
      },
      (err) => {
        setIsLoadingReservation(false);
        enqueueSnackbar(err.data, {
          variant: "error",
        });
      }
    );
  };

  // Load time slots when component mounts or date changes
  useEffect(() => {
    getTimeSlots();
  }, [queryParams.selectedDate]);

  // Load reservations when time slot, daytime, or other params change
useEffect(() => {
  getReservations({
    date: queryParams.selectedDate,
    dayTime: selectedDayTime,
    pageNumber: queryParams.pageNumber,
    pageSize: queryParams.pageSize,
    // all statuses: the status filter of the sidebar is applied on the page (it shows a count per status)
    status: "all"
  });
}, [queryParams.selectedDate, selectedDayTime, queryParams.pageNumber, queryParams.pageSize, refreshKey]);

  // Auto-select the timeslot nearest to current system time whenever slots load or dayTime changes
  useEffect(() => {
    const filtered = timeSlots.filter(s => s.dayTime === selectedDayTime);
    if (filtered.length === 0) return;
    const toMinutes = (s = "") => {
      const timePart = s.includes("T") ? s.split("T").pop() : s;
      const [h, m] = timePart.split(":").map(Number);
      return (h || 0) * 60 + (m || 0);
    };
    const now = dayjs();
    const nowMinutes = now.hour() * 60 + now.minute();
    const nearest = filtered.reduce((best, slot) =>
      Math.abs(toMinutes(slot.startDateTime) - nowMinutes) < Math.abs(toMinutes(best.startDateTime) - nowMinutes)
        ? slot : best
    );
    setSelectedTimeSlot(nearest);
  }, [timeSlots, selectedDayTime]);

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment != null) {
      setSelectedDayTime(newAlignment);
      setAlignment(newAlignment);
      setQueryParams({ ...queryParams, selectedDayTime: newAlignment });

      setSelectedTimeSlot(null);
          
    }
  };

  const handleTimeSlotClick = (timeSlot) => {
    setSelectedTimeSlot(prev => prev?.id === timeSlot.id ? null : timeSlot);
  };

  const componentRef = useRef();
  const timeSlotsScrollRef = useRef();

  const scrollSlots = (dir) => {
    if (timeSlotsScrollRef.current)
      timeSlotsScrollRef.current.scrollBy({ left: dir * 240, behavior: "smooth" });
  };

  const handlePrint = () => {
    getAllPrintReservations({
      date: queryParams.selectedDate,
      dayTime: selectedDayTime,
      status: queryParams.status
    });
  };
  const print = useReactToPrint({
    content: () => componentRef.current
  });

  const dispatch = useDispatch();

  const useStyles = makeStyles((theme) => ({
    toggleButton: {
      backgroundColor: "#ffffff",
      color: "#333",
      '&.Mui-selected': {
        backgroundColor: "#C0C0C0",
        color: "#000",
        border: "1px solid #ccc",
        '&:hover': {
          backgroundColor: "#C0C0C0",
        },
      },
      '&:hover': {
        backgroundColor: "#C0C0C0",
      },
    },
    timeSlotsWrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      borderRadius: "16px",
      padding: "12px 52px",
      boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
      border: "1px solid #e8edf2",
    },
    timeSlotsNavBtn: {
      position: "absolute",
      backgroundColor: "#004467",
      color: "#ffffff",
      width: "34px",
      height: "34px",
      transition: "background 0.2s",
      zIndex: 1,
      "&:hover": { backgroundColor: "#003255" },
      "&:disabled": { backgroundColor: "#c5d0d8", color: "#fff" },
    },
    sidePanel: {
      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      borderRadius: "16px",
      padding: "16px",
      boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
      border: "1px solid #e8edf2",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    sidePanelLabel: {
      fontSize: "10px",
      fontWeight: "700",
      letterSpacing: "0.8px",
      textTransform: "uppercase",
      color: "#8a9bb0",
    },
    timeSlotsGrid: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
    },
    timeSlotsContainer: {
      display: "flex",
      overflowX: "auto",
      gap: "14px",
      padding: "16px 20px",
      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      borderRadius: "16px",
      alignItems: "center",
      border: "1px solid #e8edf2",
      boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      scrollBehavior: "smooth",
      flex: 1,
    },
    timeSlotCard: {
      minWidth: "88px",
      padding: "10px 18px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.2s ease",
      backgroundColor: "#ffffff",
      border: "1.5px solid #dce3ea",
      borderRadius: "10px",
      userSelect: "none",
      boxShadow: "0 1px 4px rgba(0,68,103,0.07)",
      '&:hover': {
        transform: "translateY(-3px)",
        boxShadow: "0 6px 16px rgba(0,68,103,0.18)",
        borderColor: "#004467",
      },
    },
    selectedTimeSlot: {
      backgroundColor: "#004467",
      borderColor: "#004467",
      boxShadow: "0 6px 16px rgba(0,68,103,0.35)",
      transform: "translateY(-3px)",
    },
    timeSlotTime: {
      fontSize: "15px",
      fontWeight: "700",
      letterSpacing: "0.5px",
    },
    daytimeContainer: {
      background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
      borderRadius: "16px",
      padding: "16px",
      boxShadow: "0 2px 12px rgba(0,68,103,0.08)",
      border: "1px solid #e8edf2",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
  }));

  const toggleClasses = useStyles();

  const [stopStatus, setStopStatus] = useState("ok");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [changingStopStatus, setChangingStopStatus] = useState(false);

  useEffect(() => {
    setChangingStopStatus(true);
    Get({
      targetDate: queryParams.selectedDate,
      dayTime: queryParams.selectedDayTime
    },
      "ReservationStop/GetStopReservationStatus",
      null,
      resp => {
        setStopStatus(resp.data);
        setChangingStopStatus(false);
      },
      error => {
        setChangingStopStatus(false);
      }
    );
  }, [queryParams.selectedDate,queryParams.selectedDayTime]);

  const stopReservations = () => {
    setChangingStopStatus(true);
    Post(
      { targetDate: queryParams.selectedDate, dayTime: selectedDayTime },
      "Reservation/StopReservations",
      null,
      resp => {
        setStopStatus((prev) => (prev === "stopped" ? "ok" : "stopped"));
        setChangingStopStatus(false);
        enqueueSnackbar(
          `${getTranslation("Reservations for")} ${format("date", queryParams.selectedDate)}: ${stopStatus === "stopped" ? getTranslation("enabled") : getTranslation("stopped")}.`
        );
      },
      error => {
        enqueueSnackbar(`${getTranslation("Reservations for")} ${format("date", queryParams.selectedDate)}: ${getTranslation("already stopped")}.`);
        setChangingStopStatus(false);
      }
    );
  };

  const isMobileDevice = (breakpoint = 768) => {
    if (typeof window !== "undefined") {
      const width = window.innerWidth || document.documentElement.clientWidth;
      if (width <= breakpoint) return true;
      const screenWidth = window.screen.width;
      if (screenWidth <= breakpoint) return true;
    }
    if (typeof navigator !== "undefined") {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
    }
    return false;
  };

// reservations of the selected time slot (all statuses): used for the status counts
const slotReservations = () =>
  selectedTimeSlot
    ? reservations.filter(r => r.timeSlots?.some(ts => ts.id === selectedTimeSlot.id))
    : reservations;
// status filter of the sidebar (0 reserved = not confirmed, 1 confirmed)
const matchesStatus = (r, status) =>
  status === "notconfirmed" ? r.status === 0 : status === "confirmed" ? r.status === 1 : true;
const statusCounts = {
  all: slotReservations().length,
  notconfirmed: slotReservations().filter(r => matchesStatus(r, "notconfirmed")).length,
  confirmed: slotReservations().filter(r => matchesStatus(r, "confirmed")).length,
};
const filteredReservations = () => {
  const filtered = slotReservations().filter(r => matchesStatus(r, queryParams.status));
  return [...filtered].sort((a, b) => {
    const aTime = a.timeSlots?.[0]?.startDateTime ?? "";
    const bTime = b.timeSlots?.[0]?.startDateTime ?? "";
    return dayjs(aTime).diff(dayjs(bTime));
  });
};
const getSlotCount = (slotId) =>
  reservations.filter(r => r.timeSlots?.some(ts => ts.id === slotId)).length;
  return (
    <div className={classes.page}>
      <Helmet>
        <title>{getTranslation("Reservations", "Reservations", "Reservations")}</title>
      </Helmet>

      {/* Full-width day selector */}
      <Filtration params={queryParams} setParams={setQueryParams} />

      {/* 2-column layout */}
      <div className={classes.twoCol}>

        {/* ── LEFT SIDEBAR ── */}
        <div className={classes.sidebar}>

          {/* Session toggle */}
          <div className={toggleClasses.daytimeContainer}>
            <Typography className={toggleClasses.sidePanelLabel}>{getTranslation("Session")}</Typography>
            <StyledToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
              aria-label="text alignment"
              orientation="vertical"
              style={{ width: "100%" }}
            >
              <ToggleButton value={0} aria-label="morning" style={{ justifyContent: "flex-start", gap: "8px" }}>
                <WbSunnyIcon fontSize="small" />
                {getTranslation("Morning", "Morning", "Morning")}
              </ToggleButton>
              <ToggleButton value={1} aria-label="evening" style={{ justifyContent: "flex-start", gap: "8px" }}>
                <Brightness6Icon fontSize="small" />
                {getTranslation("Evening", "Evening", "Evening")}
              </ToggleButton>
            </StyledToggleButtonGroup>
          </div>

          {/* Status filter */}
          <div className={toggleClasses.daytimeContainer}>
            <Typography className={toggleClasses.sidePanelLabel}>{getTranslation("Status")}</Typography>
            <StyledToggleButtonGroup
              value={queryParams.status}
              exclusive
              onChange={(e, value) => {
                if (value) setQueryParams({ ...queryParams, status: value });
              }}
              aria-label="status"
              orientation="vertical"
              style={{ width: "100%" }}
            >
              {[
                ["all", getTranslation("All")],
                ["notconfirmed", getTranslation("Not Confirmed")],
                ["confirmed", getTranslation("Confirmed")],
              ].map(([value, label]) => (
                <ToggleButton key={value} value={value} style={{ justifyContent: "space-between" }}>
                  <span>{label}</span>
                  <span style={{ fontWeight: 700 }}>{statusCounts[value]}</span>
                </ToggleButton>
              ))}
            </StyledToggleButtonGroup>
          </div>

          {/* Stats */}
          <Progressbar stats={stats} tableSummary={printData} />

        </div>
        {/* ── END SIDEBAR ── */}

        {/* ── MAIN CONTENT ── */}
        <div className={classes.mainContent}>

          {/* Time Slots with nav */}
          <div className={toggleClasses.timeSlotsWrapper} style={{ marginBottom: "14px" }}>
            <IconButton className={toggleClasses.timeSlotsNavBtn} size="small" onClick={() => scrollSlots(-1)} style={{ left: "8px" }}>
              <ChevronLeft fontSize="small" />
            </IconButton>

            {isLoadingTimeSlots ? (
              <div className={toggleClasses.timeSlotsContainer} style={{ justifyContent: "center" }}>
                <CircularProgress size={24} style={{ color: "#004467" }} />
              </div>
            ) : timeSlots.filter(s => s.dayTime === selectedDayTime).length > 0 ? (
              <div className={toggleClasses.timeSlotsContainer} ref={timeSlotsScrollRef}>
                {timeSlots
                  .filter(slot => slot.dayTime === selectedDayTime)
                  .map((timeSlot) => {
                    const isSelected = selectedTimeSlot?.id === timeSlot.id;
                    const count = getSlotCount(timeSlot.id);
                    return (
                      <Badge
                        key={timeSlot.id}
                        badgeContent={count}
                        color="secondary"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        showZero={false}
                      >
                        <Paper
                          className={`${toggleClasses.timeSlotCard} ${isSelected ? toggleClasses.selectedTimeSlot : ""}`}
                          onClick={() => handleTimeSlotClick(timeSlot)}
                          elevation={0}
                        >
                          <Typography
                            className={toggleClasses.timeSlotTime}
                            style={{ color: isSelected ? "#ffffff" : "#004467" }}
                          >
                            {format("time", timeSlot.startDateTime)}
                          </Typography>
                        </Paper>
                      </Badge>
                    );
                  })}
              </div>
            ) : (
              <div className={toggleClasses.timeSlotsContainer} style={{ justifyContent: "center" }}>
                <Typography style={{ color: "#8a9bb0", fontSize: "13px" }}>
                  {getTranslation("No slots for")}{" "}{selectedDayTime === 0 ? getTranslation("Morning") : getTranslation("Evening")}
                </Typography>
              </div>
            )}

            <IconButton className={toggleClasses.timeSlotsNavBtn} size="small" onClick={() => scrollSlots(1)} style={{ right: "8px" }}>
              <ChevronRight fontSize="small" />
            </IconButton>
          </div>

        <CardComponent
          title={
            <Box display="flex" alignItems="center">
              <Typography>
                {getTranslation("Reservations")}
              </Typography>
              <StopReservationButton
                onClick={() => setConfirmOpen(true)}
                stopped={stopStatus === "stopped"}
                stopping={false}
                style={{ marginLeft: "20px" }}
              />
              <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
              >
                <DialogTitle>{getTranslation("Are you sure?")}</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    {stopStatus === "stopped"
                      ? getTranslation("Do you want to enable reservations again?")
                      : getTranslation("Do you really want to stop reservations?")}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setConfirmOpen(false)} color="primary">
                    {getTranslation("No")}
                  </Button>
                  <Button
                    onClick={() => {
                      setConfirmOpen(false);
                      stopReservations();
                    }}
                    color="secondary"
                    autoFocus
                  >
                    {getTranslation("Yes")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          }
          action={
            <>
              <PrintRounded
                color="secondary"
                style={{ cursor: "pointer" }}
                onClick={handlePrint}
              />
              <AddCircleOutline
                color="secondary"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowAddReservationForm(true);
                }}
              />
              <ToggleButtonGroup
                value={view}
                exclusive
                onChange={(e, value) => {
                  if (value)
                    setView(value)
                }}
                aria-label="view type"
                style={{ marginLeft: "20px" }}
              >
                <ToggleButton value="seating" aria-label="Seating view" className={toggleClasses.toggleButton}>
                  <EventSeat />
                </ToggleButton>
                <ToggleButton value="table" aria-label="table view" className={toggleClasses.toggleButton}>
                  <TableChart />
                </ToggleButton>
              </ToggleButtonGroup>
            </>
          }
        >
          {isLoadingReservation ? (
            <CircularProgress />
          ) : view == "table" ? (
            isMobileDevice() ?
              <ReservationMobileView
                reservations={filteredReservations()}
                params={queryParams}
                setParams={setQueryParams}
                loading={isLoadingReservation}
                stats={stats}
                printData={printData}
                refreshReservations={() => {
                  setRefreshKey((k) => k + 1);
                  dispatch({
                    type: SET_LASTUPDATEOFRESERVATIONS,
                    payload: new Date(),
                  });
                }}
                ref={componentRef}
              /> : <ReservationTable
                reservations={filteredReservations()}
                params={queryParams}
                setParams={setQueryParams}
                loading={isLoadingReservation}
                stats={stats}
                printData={printData}
                refreshReservations={() => {
                  setRefreshKey((k) => k + 1);
                  dispatch({
                    type: SET_LASTUPDATEOFRESERVATIONS,
                    payload: new Date(),
                  });
                }}
                ref={componentRef}
              />
          ) : <SeatingPlanCanvas
            reservations={filteredReservations()}
            queryParams={queryParams}
            timeSlots={timeSlots}
            selectedTimeSlot={selectedTimeSlot}
            onTimeSlotClick={handleTimeSlotClick}
            isLoadingTimeSlots={isLoadingTimeSlots}
            selectedDayTime={selectedDayTime}
            slotCount={getSlotCount}
          />}
        </CardComponent>
        </div>
        {/* ── END MAIN CONTENT ── */}

      </div>
      {/* ── END 2-COL ── */}

      <EditReservationModal
        isEdit
        openModal={!!linkedReservation}
        onClose={() => setLinkedReservation(null)}
        selectedReservation={linkedReservation}
        params={queryParams}
        setParams={setQueryParams}
        refreshReservations={() => setRefreshKey((k) => k + 1)}
      />

      {/* room so the floating button never hides the last reservation */}
      {isMobileDevice() && <Box height={96} />}

      {/* phone: the "+" of the reservations header is far down the page, keep one always visible */}
      {isMobileDevice() && !showAddReservationForm && (
        <Fab
          color="secondary"
          aria-label={getTranslation("Add Reservation", "Ajouter une réservation", "Reservierung hinzufügen")}
          onClick={() => setShowAddReservationForm(true)}
          style={{
            position: "fixed",
            right: 20,
            bottom: "calc(24px + env(safe-area-inset-bottom))",
            zIndex: 1200,
            color: "#fff",
          }}
        >
          <Add fontSize="large" />
        </Fab>
      )}

      <AddReservationModal
        open={showAddReservationForm}
        onClose={() => setShowAddReservationForm(false)}
        refreshReservations={() => {
          getReservations({
            date: queryParams.selectedDate,
            dayTime: selectedDayTime,
            pageNumber: queryParams.pageNumber,
            pageSize: queryParams.pageSize,
            status: "all"
          });
          dispatch({
            type: SET_LASTUPDATEOFRESERVATIONS,
            payload: new Date(),
          });
          getTimeSlots();
        }}
      />
    </div>
  );
};

export default CurrentReservation;